import React, { FC } from 'react';
import { colors } from 'constants/colors';
import { URL } from 'constants/urlMaps';
import AppStoreImg from 'assets/images/app-store.svg';
import GooglePlayImg from 'assets/images/google-play.svg';
import { IProductsGroup } from 'Modules/Shops/types';
import useRootUrlWithSubdomain from 'utils/hooks/useRootUrlWithSubdomain';
import {
  Container,
  Company,
  LogoLink,
  Rights,
  Nav,
  Shops,
  ContactsWrapper,
  ContactsBlock,
  Stores,
  StoreLink,
  StoreImg,
  ExternalNavLink,
} from './styled';
import { getYear } from 'utils/date';
import { Flex } from '@igooods/ui-kit';

export const FOOTER_LINKS_TEST_ID = 'FOOTER_LINKS_TEST_ID';
export const LANDING_FOOTER_TEST_ID = 'LANDING_FOOTER_TEST_ID';

const navMap = [
  {
    text: 'Как это работает',
    url: URL.how_it_works,
  },
  {
    text: 'Выбор товара и оплата',
    url: URL.payment,
  },
  {
    text: 'Доставка',
    url: URL.delivery,
  },
  {
    text: 'Доставка для бизнеса',
    url: URL.business,
  },
  {
    text: 'Работа в igooods',
    url: URL.rabota_v_igooods,
  },
  {
    text: 'Реквизиты франчайзи',
    url: URL.fr_details,
  },
];

interface IFooterWithSeoLinks {
  groups?: IProductsGroup[];
}

const FooterWithSeoLinks: FC<IFooterWithSeoLinks> = ({ groups }) => {
  const { mainRoute } = useRootUrlWithSubdomain();
  const currentYear = getYear();

  return (
    <Container data-testid={LANDING_FOOTER_TEST_ID}>
      <Company column>
        <LogoLink />
        <Rights color={colors.pencilGrey}>© igooods 2014—{currentYear}</Rights>
      </Company>
      <Flex ml={10} grow hideBefore="md" data-testid={FOOTER_LINKS_TEST_ID}>
        <Nav>
          {navMap.map(({ text, url }) => (
            <ExternalNavLink key={text} href={`${mainRoute}${url}`}>
              {text}
            </ExternalNavLink>
          ))}
          <ExternalNavLink href={URL.franchisee}>Франшиза</ExternalNavLink>
        </Nav>

        {groups && (
          <Shops>
            {groups.map(({ group, seo_name }) => (
              <ExternalNavLink key={group} href={`${mainRoute}/${seo_name}-dostavka-produktov-na-dom`}>
                {group} доставка продуктов
              </ExternalNavLink>
            ))}
          </Shops>
        )}
      </Flex>
      <ContactsWrapper>
        <ContactsBlock />
        <Stores>
          <StoreLink href={URL.app_store}>
            <StoreImg src={AppStoreImg} alt="app store" data-loading="lazy" />
          </StoreLink>
          <StoreLink href={URL.google_play}>
            <StoreImg src={GooglePlayImg} alt="Google play" data-loading="lazy" />
          </StoreLink>
        </Stores>
      </ContactsWrapper>
    </Container>
  );
};

export default FooterWithSeoLinks;
